export const passwordValidSteps: {
  id: number;
  validType: string;
  text: string;
}[] = [
  {
    id: 1,
    validType: 'characters',
    text: '8 - characters',
  },
  {
    id: 2,
    validType: 'symbol',
    text: '1 special symbol',
  },
  {
    id: 3,
    validType: 'uppercase',
    text: '1 uppercase letter (A-Z)',
  },
  {
    id: 4,
    validType: 'lowercase',
    text: '1 lowercase letter (a-z)',
  },
  {
    id: 5,
    validType: 'number',
    text: '1 number (0-9)',
  },
];
